import saveAs from 'file-saver';
import type { FileResponse } from '@shared/api';

export class FileUtils {
  static downloadFile = (file: FileResponse, defaultFileName = 'download') => {
    const data = new Blob([file.data]);

    const reFileName = /filename="?((?<fileName>[^".;]+)[.]?(?<fileType>[a-zA-Z0-9]+)?)"?/.exec(file.contentDisposition);
    const fileName = reFileName?.groups?.fileName?.trim() ?? defaultFileName;
    const fileType = this.getFileExtensions(file) || reFileName?.groups?.fileType?.trim();
    const fullFileName = `${fileName}.${fileType}`;

    saveAs(data, fullFileName);
  };

  static openFile = (file: FileResponse) => {
    const blob = new Blob([file.data], { type: file.contentType || 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const win = window.open(url, '_blank');

    if (!win) {
      window.setTimeout(() => URL.revokeObjectURL(url), 60000);
      return;
    }

    const timerId = window.setInterval(() => {
      if (!win.closed) return;
      clearInterval(timerId);
      URL.revokeObjectURL(url);
    }, 1000);
  };

  static getFileExtensions = (file: FileResponse) => {
    const contentType = file.contentType;
    if (!contentType) return '';

    const map: Record<string, string> = {
      'application/pdf': 'pdf',
      'application/vnd.ms-excel': 'xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'application/json': 'json',
      'image/jpeg': 'jpeg',
      'image/pjpeg': 'pjpeg',
      'image/jfif': 'jfif',
      'image/png': 'png',
      'image/gif': 'gif',
      'image/bmp': 'bmp',
      'image/webp': 'webp',
      'image/svg+xml': 'svg',
      'image/svgz': 'svgz',
      'image/ico': 'ico',
      'image/xbm': 'xbm',
      'image/dib': 'dib',
      'image/pjp': 'pjp',
      'image/tiff': 'tiff',
      'image/tif': 'tif',
      'image/avif': 'avif',
      'image/apng': 'apng',
    };

    return map[contentType];
  };
}
